import { Message } from 'element-ui';
import { removeToken } from '@/utils/auth';

/**
 * 处理状态码
 * @param {number} status 状态码
 * @param {string} message 错误信息
 */
export function handleStatus(status, message) {
  switch (status) {
    // token失效，需重登系统
    case 401:
      removeToken();
      location.href = process.env.VUE_APP_ENTRY_URL;
      break;
    default:
      break;
  }
  Message({
    showClose: true,
    message,
    type: 'error',
    duration: 10 * 1000,
  });
}
